import * as React from "react";
import {
  BooleanInput,
  Create,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
} from "react-admin";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { TitleHomebaseWarehouse } from "./Constant/Constant";

const HomebaseWarehouseCreate = props => {
  const notify = useNotify();

  const onFailure = error => notify(error?.response?.data, { type: "warning" });

  return (
    <Create {...props} title={TitleHomebaseWarehouse.create} onFailure={onFailure}>
      <SimpleForm redirect={"/homebasewarehouses"}>
        <ReferenceInput
          label="Customer"
          source="customerId"
          reference={SourceCustomer}
          perPage={99999}
          sort={{ field: "id", order: "ASC" }}
          style={{ width: 400 }}
          validate={[required()]}
        >
          <SelectInput optionValue="id" optionText="customerName" />
        </ReferenceInput>
        <TextInput source="location" validate={[required()]} style={{ width: 400 }} />
        <BooleanInput source="isActive" defaultValue={true} style={{ width: 400 }} />
      </SimpleForm>
    </Create>
  );
};

export default HomebaseWarehouseCreate;
